export default {
  badge: 'In Einrichtung',
  title: 'Schließe die Einrichtung deines Restaurants ab',
  description: 'Es fehlen nur noch wenige Schritte, bis dein Restaurant online gehen kann.',
  count: '{{done}} von {{total}} Schritten erledigt',
  cta: 'Einrichtung fortsetzen',
  done: {
    badge: 'Alles erledigt',
    title: 'Du bist startklar',
    description: '{{partner}} schaltet dein Restaurant live.',
    fallback_partner: 'Dein Anbieter',
  },
};
